import { useAuth0 } from '@auth0/auth0-react';
import { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { mcpAllowedScopes } from '@clh/mcp-scopes';
import { unwrapError, useConfig } from '@clh/ui';

import { useToast } from '../hooks/use-toast';

import Chat from './chat';
import { ChatSidebar } from './chat-sidebar';

export default function ChatLayout() {
    const config = useConfig();
    const { getAccessTokenSilently } = useAuth0();
    const { notification } = useToast();
    const [chatToken, setChatToken] = useState<string | null>(null);
    const { conversationId: urlConversationId } = useParams<{
        conversationId: string;
    }>();
    const navigate = useNavigate();
    const [activeConversationId, setActiveConversationId] = useState<
        string | null
    >(urlConversationId ?? null);
    const [chatKey, setChatKey] = useState(0);

    useEffect(() => {
        setActiveConversationId(urlConversationId ?? null);
    }, [urlConversationId]);

    const handleNewConversation = useCallback(() => {
        navigate('/chat');
        setActiveConversationId(null);
        setChatKey((prev) => prev + 1);
    }, [navigate]);

    useEffect(() => {
        getAccessTokenSilently({
            authorizationParams: {
                audience: config.apiAuth0Audience as string,
                scope: mcpAllowedScopes.join(' '),
            },
        })
            .then(setChatToken)
            .catch((err) => {
                notification.error({
                    message: unwrapError(err),
                    duration: 3,
                });
            });
    }, [getAccessTokenSilently, config.apiAuth0Audience]);

    return (
        <div style={{ display: 'flex', height: '100vh', width: '100%' }}>
            <ChatSidebar
                apiBaseUrl={config.apiBaseUrl as string}
                chatToken={chatToken}
                activeConversationId={activeConversationId}
                onNewConversation={handleNewConversation}
            />
            <div style={{ flex: 1, minWidth: 0 }}>
                <Chat
                    key={urlConversationId ?? `new-${chatKey}`}
                    chatToken={chatToken}
                    onConversationChange={setActiveConversationId}
                />
            </div>
        </div>
    );
}
